import { mergeInvoiceProductCatalog } from './invoiceProductCatalog';

/**
 * Fatura şartları — tek tip, sırayla denenen kural listesi.
 *
 * Eskiden dört ayrı yerde kural vardı (tutar şartları, kısmi ödeme ürün seçimi,
 * kredi kartı, kategori eşlemeleri) ve hangisinin ne zaman çalıştığı ekrandan
 * anlaşılmıyordu. Artık hepsi aynı biçimde tek listede: yukarıdan aşağı ilk
 * uyan şart uygulanır.
 *
 * Şart = KOŞULLAR + SONUÇ. Boş bırakılan koşul "hepsi" demektir.
 */

/**
 * Çoklu seçim listeleri. HİÇBİRİ seçilmezse "hepsi" demektir — ayrıca bir
 * "Hepsi" seçeneği tutulmuyor, boş bırakmak aynı anlama geliyor.
 */

/** Hangi işleme uygulanacak (işlemin islemTuru alanı) */
export const SART_ISLEM_TURU = [
  { value: 'Satış', label: 'Satış' },
  { value: 'Giriş', label: 'Giriş' },
  { value: 'Alış', label: 'Alış' },
  { value: 'Çıkış', label: 'Çıkış' }
];

/**
 * Para nereden geldi. Nakit YOK: nakde hiç fatura kesilmiyor, kuralda seçenek
 * olarak durması yalnızca karışıklık yaratıyordu.
 */
export const SART_ODEME_KANALI = [
  { value: 'havale', label: 'Havale / EFT' },
  { value: 'krediKarti', label: 'Kredi kartı' }
];

/** Tutarın tamamı mı bankadan geldi, bir kısmı mı */
export const SART_ODEME_SEKLI = [
  { value: 'hepsi', label: 'Farketmez' },
  { value: 'tamami', label: 'Tamamı bankadan' },
  { value: 'kismi', label: 'Bir kısmı bankadan' }
];

/** İşlemin ürün kategorisi */
export const SART_KATEGORI = [
  { value: 'Sarrafiye', label: 'Sarrafiye' },
  { value: 'Gram Altın', label: 'Gram Altın' },
  { value: 'Takı Ürün', label: 'Takı Ürün' },
  { value: 'Hurda', label: 'Hurda' },
  { value: 'Döviz', label: 'Döviz' },
  { value: 'Genel', label: 'Genel / diğer' }
];

/**
 * Tek tek ÜRÜN koşulu. Kategori yetmediği durumlar için: ör. 0,25 ve 0,50
 * gramlık külçeler satılınca faturaya kesirli miktar ("0,5 adet 24 Ayar Gram
 * Altın") yazılıyordu; gram altın hep tam sayı adetle kesilmeli. Bu ürünlere
 * özel şart yazılabilsin diye eklendi.
 *
 * Seçenekler katalogdan gelir, böylece ürün eklenince liste kendiliğinden
 * güncellenir.
 */
export const sartUrunSecenekleri = (catalog) =>
  mergeInvoiceProductCatalog(catalog)
    .filter((r) => r.productName)
    .map((r) => ({ value: r.productName, label: r.productName, kategori: r.category }));

/** Tutar koşulu */
export const SART_TUTAR_KOSULU = [
  { value: 'yok', label: 'Tutara bakma' },
  { value: 'altinda', label: 'Şu tutarın altında' },
  { value: 'ustunde', label: 'Şu tutar ve üzerinde' },
  { value: 'arasinda', label: 'Şu iki tutar arasında' }
];

/** Şart uyunca ne olsun */
export const SART_SONUCU = [
  /** Urunu degistirme: islemdeki urun neyse faturaya o yazilir (kategori tablosu). */
  { value: 'olduguGibi', label: 'İşlemdeki ürünü olduğu gibi kes' },
  /** Tartılan ürünlerde (takı, hurda) doğru davranış: ürün aynı kalır, gram düşer. */
  { value: 'miktarDusur', label: 'Ürünü koru, miktarı tutara göre düşür' },
  { value: 'tamir', label: 'Altın Tamir Ücreti olarak kes' },
  { value: '24gram', label: '24 Ayar Gram Altın olarak kes' },
  { value: '22gram', label: '22 Ayar Gram Altın olarak kes' },
  { value: '22taki', label: '22 Ayar Takı olarak kes' },
  { value: '22bilezik', label: '22 Ayar Bilezik olarak kes' },
  { value: '14taki', label: '14 Ayar Takı olarak kes' },
  { value: '8taki', label: '8 Ayar Takı olarak kes' },
  { value: 'enYakinUrun', label: 'Tutara en yakın ürün olarak kes' },
  { value: 'faturaKesme', label: 'Fatura kesme (atla)' }
];

const yeniId = () => `sart-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
const sayi = (v, varsayilan = 0) => (Number.isFinite(Number(v)) ? Number(v) : varsayilan);
const dizi = (v) => (Array.isArray(v) ? v.filter(Boolean).map(String) : []);

/** Eksik alanları tamamlanmış şart nesnesi. */
export const createInvoiceRule = (kismi = {}) => ({
  id: kismi.id || yeniId(),
  enabled: kismi.enabled !== false,
  islemTurleri: dizi(kismi.islemTurleri),
  odemeKanallari: dizi(kismi.odemeKanallari),
  kategoriler: dizi(kismi.kategoriler),
  /** Boş = tüm ürünler. Doluysa yalnız bu ürün adları. */
  urunler: dizi(kismi.urunler),
  odemeSekli: kismi.odemeSekli || 'hepsi',
  tutarKosulu: kismi.tutarKosulu || 'yok',
  tutarMin: sayi(kismi.tutarMin, 0),
  tutarMax: sayi(kismi.tutarMax, 0),
  sonuc: kismi.sonuc || 'olduguGibi',
  /** sonuc === 'enYakinUrun' iken kullanılır: kabul edilen fiyat farkı */
  toleransTl: sayi(kismi.toleransTl, 200)
});

export const mergeInvoiceRules = (ham) =>
  (Array.isArray(ham) ? ham : []).map((r) => createInvoiceRule(r));

/** Şartı tek cümlede özetler — listede ve taslak gerekçesinde kullanılır. */
export const describeInvoiceRule = (rule) => {
  const r = createInvoiceRule(rule);
  const et = (liste, v) => liste.find((o) => o.value === v)?.label || v;
  const etiketler = (liste, secilenler) => secilenler.map((v) => et(liste, v)).join(' / ');
  const kosullar = [];
  if (r.islemTurleri.length) kosullar.push(etiketler(SART_ISLEM_TURU, r.islemTurleri));
  if (r.kategoriler.length) kosullar.push(etiketler(SART_KATEGORI, r.kategoriler));
  if (r.urunler.length) kosullar.push(r.urunler.join(' / '));
  if (r.odemeKanallari.length) kosullar.push(etiketler(SART_ODEME_KANALI, r.odemeKanallari));
  if (r.odemeSekli !== 'hepsi') kosullar.push(et(SART_ODEME_SEKLI, r.odemeSekli).toLowerCase());
  const tl = (n) => `${Number(n).toLocaleString('tr-TR')} TL`;
  if (r.tutarKosulu === 'altinda') kosullar.push(`${tl(r.tutarMin)} altında`);
  if (r.tutarKosulu === 'ustunde') kosullar.push(`${tl(r.tutarMin)} ve üzeri`);
  if (r.tutarKosulu === 'arasinda') kosullar.push(`${tl(r.tutarMin)} – ${tl(r.tutarMax)}`);
  const sol = kosullar.length ? kosullar.join(' · ') : 'Her işlem';
  return `${sol} → ${et(SART_SONUCU, r.sonuc)}`;
};

/**
 * `alt` şartı, `ust` şartı yüzünden HİÇ çalışamaz mı?
 *
 * Sadece kesişim aramak yanlış alarm veriyordu: sıralı denendiği için iki şart
 * kesişse de alttaki kalan durumlarda çalışmaya devam edebilir. Uyarı yalnız
 * alttaki tamamen gölgede kalıyorsa — yani üstteki onun her durumunu da
 * yakalıyorsa — anlamlı.
 */
export const ruleIsShadowed = (alt, ust) => {
  const a = createInvoiceRule(alt);
  const u = createInvoiceRule(ust);
  if (u.enabled === false) return false;
  // "Tutara en yakın ürün" sonucu bulamazsa alttaki şarta geçer; bu yüzden
  // hiçbir zaman alttakini tamamen gölgelemez.
  if (u.sonuc === 'enYakinUrun') return false;

  // Ustteki liste bos (hepsi) olmali ya da alttakinin tamamini kapsamali.
  const kapsar = (ustListe, altListe) => {
    if (!ustListe.length) return true;
    if (!altListe.length) return false;
    return altListe.every((v) => ustListe.includes(v));
  };
  if (!kapsar(u.islemTurleri, a.islemTurleri)) return false;
  if (!kapsar(u.odemeKanallari, a.odemeKanallari)) return false;
  if (!kapsar(u.kategoriler, a.kategoriler)) return false;
  if (!kapsar(u.urunler, a.urunler)) return false;
  if (u.odemeSekli !== 'hepsi' && u.odemeSekli !== a.odemeSekli) return false;

  const aralik = (r) => {
    if (r.tutarKosulu === 'altinda') return [0, r.tutarMin];
    if (r.tutarKosulu === 'ustunde') return [r.tutarMin, Infinity];
    if (r.tutarKosulu === 'arasinda') return [r.tutarMin, r.tutarMax];
    return [0, Infinity];
  };
  const [uMin, uMax] = aralik(u);
  const [aMin, aMax] = aralik(a);
  // Ustteki tutar araligi alttakini tamamen iceriyor mu?
  return uMin <= aMin && uMax >= aMax;
};

/**
 * Bu taslak hangi ödemenin faturası?
 *
 * Karma ödemede sistem kart için ayrı, banka hareketi için ayrı taslak açıyor.
 * "Ödeme" koşulu işlemde o kanal VAR MI diye bakarsa, kart kuralı havale
 * faturasını da durdurur; o yüzden taslağın kendi kanalına bakılıyor.
 */
export const resolveIslemKanal = (islem) => {
  if (islem?.krediKartiKaynak || String(islem?.invoiceSource || '') === 'krediKarti') return 'krediKarti';
  if (sayi(islem?.havaleEft, 0) > 0) return 'havale';
  if (sayi(islem?.nakit, 0) > 0) return 'nakit';
  if (sayi(islem?.krediKarti, 0) > 0) return 'krediKarti';
  return '';
};

/** İşlemden şart girdilerini çıkarır. */
export const ruleInputsFromIslem = (islem, { odenecek = 0, kismiOdeme = false, kanal = null } = {}) => ({
  islemTuru: String(islem?.islemTuru || '').trim(),
  kategori: String(islem?.kategori || '').trim() || 'Genel',
  urun: String(islem?.urun || '').trim(),
  kanal: kanal || resolveIslemKanal(islem),
  krediKarti: sayi(islem?.krediKarti, 0),
  odenecek: sayi(odenecek, 0),
  kismiOdeme: Boolean(kismiOdeme)
});

/** Tek şart bu işleme uyuyor mu? */
export const ruleMatches = (rule, girdi) => {
  const r = createInvoiceRule(rule);
  if (r.enabled === false) return false;
  if (r.islemTurleri.length && !r.islemTurleri.includes(girdi.islemTuru)) return false;
  if (r.kategoriler.length && !r.kategoriler.includes(girdi.kategori)) return false;
  if (r.urunler.length && !r.urunler.includes(girdi.urun)) return false;

  // Bu taslak hangi ödemenin faturasiysa ona bakiyoruz (karma odemede ayrisir).
  if (r.odemeKanallari.length && !r.odemeKanallari.includes(girdi.kanal)) return false;

  if (r.odemeSekli === 'kismi' && !girdi.kismiOdeme) return false;
  if (r.odemeSekli === 'tamami' && girdi.kismiOdeme) return false;

  // Kart faturasinda tutar kart cekimi, digerlerinde faturalanacak tutardir.
  const tutar = girdi.kanal === 'krediKarti' ? girdi.krediKarti || girdi.odenecek : girdi.odenecek;
  if (r.tutarKosulu === 'altinda' && !(tutar < r.tutarMin)) return false;
  if (r.tutarKosulu === 'ustunde' && !(tutar >= r.tutarMin)) return false;
  if (r.tutarKosulu === 'arasinda' && !(tutar >= r.tutarMin && tutar <= r.tutarMax)) return false;

  return true;
};

/** Sırayla dener, ilk uyan şartı döner (yoksa null). */
export const resolveInvoiceRule = (rules, girdi) => {
  for (const rule of mergeInvoiceRules(rules)) {
    if (ruleMatches(rule, girdi)) return createInvoiceRule(rule);
  }
  return null;
};
